export default {
    'currencies-settings': 'Visualización de los  símbolos de moneda',
    'show-currency-symbol': 'Mostrar símbolos de monedas',
    'Asking-about-the-date-of-the-bond-accounting-or-cash-before-it-was-created': 'Especifique la fecha antes de crear un bono',
    'show-the-dialog-to-choose-the-date-instead-of-adopting-today-date': 'Mostrar cuadro de diálogo para elegir la fecha (en lugar de la fecha de hoy)',
    'open-account-statement-in-new-window': 'Abrir estado de cuenta en nueva ventana',
    'opening-account-statement-in-new-window-from-accounting-journal': 'Estado de cuenta de apertura para entrada desde el diario contable en una nueva pestaña',
}